import { type BreadcrumbKind, type BreadcrumbType } from "ui/breadcrumbs/breadcrumbs.types";

/**
 * A crumb without `href` is the current page unless it says `active: false`; `active: true` makes
 * even a linked crumb the current page.
 */
export const getBreadcrumbKind = ({ href, active }: Pick<BreadcrumbType, "href" | "active">): BreadcrumbKind => {
  if (active === false && !href) {
    return "text";
  }

  return active || !href ? "current" : "link";
};
